export default "__VITE_ASSET__a6373ab7__"